export const CAMPAIGN_PREPAID_DEPOSIT = {
  NEED_CHARGE: 1, // チャージが発生する
  NO_CHARGE: 0, // チャージが発生しない
};
